export const opsNotificationOptions = [
    {value: "Falta información", label: "Falta información"},
    {value: "Urgente", label: "Urgente"},
    {value: "Ilocalizable",label: "Ilocalizable"},
    {value: "Whatsapp enviado",label: "Whatsapp enviado"},
    {value: "Cliente confirma diagnóstico",label: "Cliente confirma diagnóstico"}
]